export const MESSAGES_TYPES = {
	SUCCESS: 'success',
	SUCCESS_CANCEL: 'success_cancel',
	ERROR: 'exception',
	PROCESSING: 'active',
	WARNING: 'warning',
	INITIAL_UPLOAD: null,
};

export const SHA_MESSAGE_TYPE = {
	PROCESSING: 'info',
	ERROR: 'error',
	SUCCESS: 'success',
};

export const VALIDATION_ERROR = {
	VERSION_INPUT: 'Invalid format: please use a-z, A-Z, 0-9 with . or _ as separators.',
	INVALID_REGEX_FORMAT: 'Invalid format: please insert value based on this Regex:',
	REGEX_VALIDATION_ERR_MSG: 'Invalid format: please use [0-9].[0-9] followed by pre[0-9] or [0-9].',
	PROJ_NAME_INPUT: 'Invalid format: please use  A-Z, 0-9 with _ or white-space.',
	GROUP_PERMISSION_INPUT_WHEN_GROUP_ENTITLEMENT_NULL: 'Invalid format: please use a-z, 0-9 with _ as separators (no white-space).',
	NUMBERS_ONLY_INPUT: 'Invalid format: please use only 0-9.',
	RTL_INPUT: 'please match the requsted format . RTLxxWWx.xA-Fxxx, e.g. RTL0.5WW21.1A_firstDrop',
	LINUX_INPUT: 'Invalid format: please use  a-z,A-Z, 0-9 with _ .',
	COMMON_INPUT: 'Invalid format: please use a-z, A-Z, 0-9 with . or _ as separators.',
	PCI_INPUT: 'Invalid format: please use "device, device" template, e.g. 8086:0xbcd, 8086:0xbce',
	GENERAL_INPUT_WITH_DASH: 'Invalid format: please use a-z, A-Z, 0-9 with . or _ or - as separators.',
	ROM_REG_ADDRESS_REGEX: 'Invalid format: please write in this format 0[xX][0-9a-fA-F]',
};

export const SELECT_DATA_ERROR = 'Unable to generate data for field';
export const LOADING = 'Loading data...';

export const NOTIFICATION_TYPES = {
	SUCCESS: 'success',
	ERROR: 'error',
	WARNING: 'warning',
	INFO: 'info',
};
export const EXPORT_DOWNLOAD_SUCCESS = 'File exported, download will start shortly';

export const EXEC_JOB_RUNNING = 'Job is running...';

export const TAGGING_MESSAGE = {
	SUCCESS: 'Tagging - success',
	ERROR: 'Tagging failed - connection already made',
};
export const INTEGRATOR_SUFFIX = ' INTEGRATOR';
export const INTEGRATOR_ENTITLEMENT_NAME = 'FPGA FARM CLOUD INTEGRATOR AD-CORP';
export const INTEGRATOR_JUSTIFICATION_QUESTIONS = `What is your BU?
What is your justification to have this entitlement?
Are you creating or publishing Release Packages in FFC to one of the pre-silicon projects?
What is the project name you need to provide a Release?`;

export const REQUEST_DESCRIPTION = 'This entitlement will provide you the ability to create & publish Release Packages in FFC';
export const REQUEST_TEXT = 'Request Permission';
export const PENDING_TEXT = 'Pending';
export const RELEASE_PACKAGE_BUTTON_NAME = 'Release Package';
export const NO_INTEGRATOR_MESSAGE = "You don't have integrator permissions";

export const REQUEST_PARAMS = {
	projectName: INTEGRATOR_ENTITLEMENT_NAME,
	requestedBy: null,
	justification: null,
	isIntegrator: true,
};

export const NONE_NOTIFICATIONS = 'No notifications';
export const UPLOAD_ING_STEP_0 = 'Preparing ingredient to upload.';
export const FINISHED_ING_STEP_0 = `Completed upload preparation, see notifications button for upload process.`;
export const UPLOAD_ERROR = `Error with upload`;
export const ERROR_MISSING_FIELDS_MESSAGE = 'ERROR: Missing Fields - One or More of the Required Fields are Empty: ';
export const NOTICE_NO_SUBMIT_CHANGES =
	'NOTICE: you have not submitted your changes! are you sure you want to discard changes?\n click OK for discard changes.\n, click CANCEL for stay on page and click on submit. ';

export const STAGES_STATUS = {
	WAITING: 'Waiting',
	LOADING: 'In Progress',
	COMPLETED: 'Completed',
};

export const SKELETON_LAYERS_ORDER = {
	FPGA: 1,
	DRIVER: 2,
	ROMS: 3,
	SPI: 4,
	SIMICS: 5,
	BIOS: 6,
	OS: 7,
};

export const LOADING_RELEASE_PACKAGES = 'Release packages updated - are loading now';
export const COPIED_TO_CLIPBOARD = 'Copied to Clipboard';
export const NO_SELECTED_VALUE = 'No Selected Value';
